import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ShieldCheck } from "lucide-react";
import { adminFetch } from "../../lib/adminApi";

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error] = useState(location.state?.error || "");

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    adminFetch("/api/auth/me").then(() => navigate("/admin/orders", { replace: true })).catch(() => {});
  }, [navigate]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/orders";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] pt-32 pb-24">
      <Helmet><title>Admin Sign In · Highwall</title><meta name="robots" content="noindex,nofollow" /></Helmet>
      <div className="max-w-md mx-auto px-6">
        <div className="bg-[#141414] border border-white/10 p-8">
          <ShieldCheck className="w-10 h-10 text-signal-red mb-4" />
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-gray-400 mb-2">Highwall Internal</p>
          <h1 className="font-heading text-3xl font-bold uppercase text-white mb-3" data-testid="admin-login-title">Orders Admin</h1>
          <p className="text-gray-400 text-sm mb-8">Authorized Highwall personnel only. Sign in with your approved Google account.</p>
          {error && <p className="mb-4 p-3 border border-signal-red/40 bg-signal-red/10 text-gray-200 text-sm" data-testid="admin-login-error">{error}</p>}
          <button type="button" onClick={signIn} className="w-full px-6 py-4 bg-signal-red text-white font-bold uppercase tracking-wide hover:bg-signal-red/90 transition-colors" data-testid="admin-google-signin">
            Sign in with Google
          </button>
          <p className="text-gray-600 text-xs mt-6">Access is limited to the Highwall admin allowlist.</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
